import { render, staticRenderFns } from "./MeetingHeader.vue?vue&type=template&id=36b21dde&scoped=true"
import script from "./MeetingHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./MeetingHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MeetingHeader.vue?vue&type=style&index=0&id=36b21dde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b21dde",
  null
  
)

export default component.exports